module.exports = __webpack_public_path__ + "static/img/jumpLink.4afef143.png";